import React, { useState, useEffect, useRef } from "react";
import useAxios from "../../hooks/useAxios";
import { PageToolbar, TooltipWrapper } from "../common";
//Helper function, external library and Interfaces
import helpers from "../../_helpers/common";
import { useParams } from "react-router-dom";
import { ProductAsset, Order } from "../../types/interfaces";


const ViewDetails: React.FC = () => {
  const axiosInstance = useAxios();
  const { order_id } = useParams();
  const [results, setResults] = useState<Order | null>(null);
  const [copied, setCopied] = useState(false);
  const [currency] = useState("Rs ");
  const initialRequest = useRef(false);

  useEffect(() => {
    if (!initialRequest.current) {
      initialRequest.current = true;
      getDetailData();
    }
    return () => {
      setResults(null);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 

  const getDetailData = async () => {
    try {
      const response: any = await axiosInstance({
        url: "orders/detail",
        method: "GET",
        data: { orderId: order_id },
      });
      //console.log("order details response", response);
      setResults(response.data.order);
    } catch (error: any) {
      console.error("Error in api request:", error);
    }
  };
  
  const copyAddress = async () => {
	  await navigator.clipboard.writeText(results?.shipping_address || "");
	  setCopied(true);

	  setTimeout(() => {
		setCopied(false);
	  }, 2000);
	};

  return (
    <>
      {/*Page toolbar Area Start*/}
      <PageToolbar
        title="Order Detail"
        step1={{ title: "Orders List", link: "/orders-list" }}
        step2={{ title: "Order Detail" }}
      />
      {/*Page toolbar Area End*/}
      <div id="kt_app_content" className="flex-column-fluid">
		  <div className="d-flex flex-column gap-7 gap-lg-10">
			 <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
				<div className="card card-flush py-4 flex-row-fluid">
				   <div className="card-header">
					  <div className="card-title">
						 <h2>Order Details (#{results?.order_number})</h2>
					  </div>
				   </div>
				   <div className="card-body pt-0">
					  <div className="table-responsive">
						 <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
							<tbody className="fw-semibold text-gray-600">
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-calendar fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										</i>Order Date
									 </div>
								  </td>
								  <td className="fw-bold text-end">{helpers.convertDateTime(
									  results?.created_at,
									  "DD MMM YYYY"
									) || "N/A"}
								  </td>
							   </tr>
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-wallet fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										<span className="path4"></span>
										</i>Payment Method
									 </div>
								  </td>
								  <td className="fw-bold text-end">Online </td>
							   </tr>
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-truck fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										<span className="path4"></span>
										<span className="path5"></span>
										</i>Shipping Method
									 </div>
								  </td>
								  <td className="fw-bold text-end">N/A</td>
							   </tr>
							</tbody>
						 </table>
					  </div>
				   </div>
				</div>
				<div className="card card-flush py-4 flex-row-fluid">
				   <div className="card-header">
					  <div className="card-title">
						 <h2>Customer Details</h2>
					  </div>
				   </div>
				   <div className="card-body pt-0">
					  <div className="table-responsive">
						 <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
							<tbody className="fw-semibold text-gray-600">
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-profile-circle fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										</i>Customer
									 </div>
								  </td>
								  <td className="fw-bold text-end">
									 <div className="d-flex align-items-center justify-content-end">
										<div className="symbol symbol-circle symbol-25px overflow-hidden me-3">
										   <span>
											  <div className="symbol-label">
												 <img
												  src={
													typeof results?.created_by === "object"
													  ? results.created_by.imagepath
													  : "/assets/media/avatars/default.png"
												  }
												  alt="User"
												  className="w-100"
												/>
											  </div>
										   </span>
										</div>
										<span className="text-gray-600 text-hover-primary">
										{
										  typeof results?.created_by === "object" && results?.created_by !== null
										  ? results?.created_by?.fullname
										  : ""
										}
										</span>
									 </div>
								  </td>
							   </tr>
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-sms fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										</i>Email
									 </div>
								  </td>
								  <td className="fw-bold text-end">
									 <span className="text-gray-600 text-hover-primary">
										{
										  typeof results?.created_by === "object" && results?.created_by !== null
										  ? results?.created_by?.email
										  : ""
										}
									  </span>
								  </td>
							   </tr>
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-phone fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										</i>Phone
									 </div>
								  </td>
								  <td className="fw-bold text-end">
									 <span className="text-gray-600 text-hover-primary">
										{
										  typeof results?.created_by === "object" && results?.created_by !== null
										  ? results?.created_by?.phone_no
										  : ""
										}
									  </span>
								  </td>
							   </tr>
							</tbody>
						 </table>
					  </div>
				   </div>
				</div>
				<div className="card card-flush py-4 flex-row-fluid">
				   <div className="card-header">
					  <div className="card-title">
						 <h2>Documents</h2>
					  </div>
				   </div>
				   <div className="card-body pt-0">
					  <div className="table-responsive">
						 <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
							<tbody className="fw-semibold text-gray-600">
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-devices fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										<span className="path4"></span>
										<span className="path5"></span>
										</i>Invoice 
										<span className="ms-1" data-bs-toggle="tooltip" aria-label="View the invoice generated by this order." data-bs-original-title="View the invoice generated by this order." data-kt-initialized="1">
										<i className="ki-duotone ki-information-5 text-gray-500 fs-6">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										</i>
										</span>
									 </div>
								  </td>
								  <td className="fw-bold text-end">
									 <span className="text-gray-600 text-hover-primary">{results?.invoice_number}</span>
								  </td>
							   </tr>
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-truck fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										<span className="path4"></span>
										<span className="path5"></span>
										</i>Shipping 
										<span className="ms-1" data-bs-toggle="tooltip" aria-label="View the shipping manifest generated by this order." data-bs-original-title="View the shipping manifest generated by this order." data-kt-initialized="1">
										<i className="ki-duotone ki-information-5 text-gray-500 fs-6">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										</i>
										</span>
									 </div>
								  </td>
								  <td className="fw-bold text-end">
									 <span className="text-gray-600 text-hover-primary">{results?.tracking_number}</span>
								  </td>
							   </tr>
							   <tr>
								  <td className="text-muted">
									 <div className="d-flex align-items-center">
										<i className="ki-duotone ki-discount fs-2 me-2">
										<span className="path1"></span>
										<span className="path2"></span>
										</i>Reward Points 
										<span className="ms-1" data-bs-toggle="tooltip" aria-label="Reward value earned by customer when purchasing this order" data-bs-original-title="Reward value earned by customer when purchasing this order" data-kt-initialized="1">
										<i className="ki-duotone ki-information-5 text-gray-500 fs-6">
										<span className="path1"></span>
										<span className="path2"></span>
										<span className="path3"></span>
										</i>
										</span>
									 </div>
								  </td>
								  <td className="fw-bold text-end">
									 <span className="text-gray-600 text-hover-primary">{results?.tracking_number}</span>
								  </td>
							   </tr>
							</tbody>
						 </table>
					  </div>
				   </div>
				</div>
			 </div>
			 <div className="tab-content">
				<div className="tab-pane fade show active" id="kt_ecommerce_sales_order_summary" role="tab-panel">
				   <div className="d-flex flex-column gap-7 gap-lg-10">
					  <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
						 <div className="card card-flush py-4 flex-row-fluid position-relative">
							<div className="position-absolute top-0 end-0 bottom-0 opacity-10 d-flex align-items-center me-5">
							   <i className="ki-solid ki-two-credit-cart" style={{ fontSize: "14em" }}></i>
							</div>
							<div className="card-header">
							   <div className="card-title">
								  <h2>
								    Billing Address
									<i
									  className={`ki-duotone ${
										copied ? "ki-check" : "ki-copy"
									  } fs-2 me-2 cursor-pointer`}
									  onClick={copyAddress}
									  title={copied ? "Copied!" : "Copy Address"}
									  style={{ cursor: "pointer" }}
									>
									  <span className="path1"></span>
									  <span className="path2"></span>
									  <span className="path3"></span>
									  <span className="path4"></span>
									  <span className="path5"></span>
									</i>
								  </h2>
							   </div>
							</div>
							<div className="card-body pt-0">
							  <div style={{ width: "100%" }}>
							    <p className="text-wrap">{results?.shipping_address}</p>
							  </div>
							</div>
						 </div>
						 <div className="card card-flush py-4 flex-row-fluid position-relative">
							<div className="position-absolute top-0 end-0 bottom-0 opacity-10 d-flex align-items-center me-5">
							   <i className="ki-solid ki-delivery" style={{ fontSize: "13em" }}></i>
							</div>
							<div className="card-header">
							   <div className="card-title">
								  <h2>
								    Shipping Address
									<i
									  className={`ki-duotone ${
										copied ? "ki-check" : "ki-copy"
									  } fs-2 me-2 cursor-pointer`}
									  onClick={copyAddress}
									  title={copied ? "Copied!" : "Copy Address"}
									  style={{ cursor: "pointer" }}
									>
									  <span className="path1"></span>
									  <span className="path2"></span>
									  <span className="path3"></span>
									  <span className="path4"></span>
									  <span className="path5"></span>
									</i>
								  </h2>
							   </div>
							</div>
							<div className="card-body pt-0">
							  <p>{results?.shipping_address}</p>
							</div>
						 </div>
					  </div>
					  <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
						<div className="card-header">
						  <div className="card-title">
							<div className="d-flex flex-column">
							  <h2>Order No: #{results?.order_number}</h2>
							  <span className="mt-3">Order Status: <span className="badge badge-primary">{results?.status}</span></span>
							</div>
						  </div>
						</div>
						<div className="card-body pt-0">
							<div className="table-responsive">
							   <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
								  <thead>
									 <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
										<th className="min-w-175px">Product</th>
										<th className="min-w-100px text-end">Qty</th>
										<th className="min-w-70px text-end">Price</th>
										<th className="min-w-100px text-end">Discount</th>
										<th className="min-w-100px text-end">Total</th>
									 </tr>
								  </thead>
								  <tbody className="fw-semibold text-gray-600">
								    {results?.order_items.map((item: any, index: number) => {
										//console.log('item', item);  
										const qty = Number(item.quantity);
										const price = Number(item.price);
										const discount = Number(item.discount || 0);
										const discountedPrice = price - discount;
										return (
										  <tr key={index}>
											<td>
											  <div className="d-flex align-items-center">
											    <span className="symbol symbol-50px">
												  <span
													  className="symbol-label"
													  style={{
														backgroundImage: `url(${item.product_id.displaypath})`
													  }}
													></span>
												</span>	
												  <div className="ms-5">
													<span className="fw-bold text-gray-600 text-hover-primary">
													  {item.product_id?.title || "Product"}
													</span>
												  </div>
											  </div>
											</td>
											<td className="text-end">{qty}</td>
											<td className="text-end">
											  {currency}{price.toFixed(2)}
											</td>
											<td className="text-end">
											  {discount ? `-${currency}${discount.toFixed(2)}` : "—"}
											</td>
											<td className="text-end">
											  {currency}{(discountedPrice * qty).toFixed(2)}
											</td>
										  </tr>
										);
									  })}
									 <tr>
										<td colSpan={4} className="text-end">Subtotal</td>
										<td className="text-end">{`${currency}${Number(results?.items_price).toFixed(2)}`}</td>
									 </tr>
									 <tr>
										<td colSpan={4} className="text-end">VAT (0%)</td>
										<td className="text-end">{`${currency}${Number(results?.tax_price).toFixed(2)}`}</td>
									 </tr>
									 <tr>
										<td colSpan={4} className="text-end">Shipping Rate</td>
										<td className="text-end">{`${currency}${Number(results?.shipping_price).toFixed(2)}`}</td>
									 </tr>
									 <tr>
										<td colSpan={4} className="fs-3 text-gray-900 text-end">Grand Total</td>
										<td className="text-gray-900 fs-3 fw-bolder text-end">{currency}{Number(results?.total_price).toFixed(2)}</td>
									 </tr>
								  </tbody>
							   </table>
							</div>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
		  </div>
	   </div>
    </>
  );
};

export default ViewDetails;